import { LinkDto } from './../shared/link.dto';
import { ContactDto } from './../shared/contact.dto';
import { ProductLineImageDto } from './image.dto';
import { BrandInstructionDto } from './../shared/brand-instruction.dto';
import { EDesignDetailDto } from './../shared';
import { ProductLabelDto } from './../product/product-label.dto';
import { ProductLineRedemptionDto } from './processing/redemption.dto';

export class ProductLineLocaleDto {
  locale: string;
  brandLinks: LinkDto | undefined;
  contactInfo: ContactDto[] | undefined;
  images: ProductLineImageDto[] | undefined;
  brandInstructions: BrandInstructionDto[] | undefined;
  eDesignDetails?: EDesignDetailDto[];
  defaultProductId: string;
  productLabels: ProductLabelDto[] | undefined;
  redemption: ProductLineRedemptionDto | undefined;
  id?: string;

  constructor(d?: ProductLineLocaleDto) {
    if (!d) {
      return;
    }

    this.locale = d.locale;
    this.brandLinks = d.brandLinks ? new LinkDto(d.brandLinks) : undefined;
    this.contactInfo = d.contactInfo
      ? d.contactInfo.map(c => new ContactDto(c))
      : undefined;
    this.images = d.images
      ? d.images.map(i => new ProductLineImageDto(i))
      : undefined;
    this.brandInstructions = d.brandInstructions
      ? d.brandInstructions.map(i => new BrandInstructionDto(i))
      : undefined;
    this.eDesignDetails = d.eDesignDetails
      ? d.eDesignDetails.map(i => new EDesignDetailDto(i))
      : undefined;
    this.defaultProductId = d.defaultProductId;
    this.productLabels = d.productLabels
      ? d.productLabels.map(l => new ProductLabelDto(l))
      : undefined;
    this.redemption = d.redemption
      ? new ProductLineRedemptionDto(d.redemption)
      : undefined;
    this.id = d.id;
  }
}
